import { EventEmitter } from '@angular/core';
import { ValidationError } from '../../../../../../models/ErrorTemplate';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../../services/user.service';
import { EventTrackerService, UserActionType, Page, ActivePages } from '../../../../../services/event-tracker/event-tracker.service';
import { ReferenceDataService } from '../../../../../services/reference-data/reference-data.service';
import { AutoGroupSourceEnum, AutoGroupSource, AutoGroupSourceValue } from '../../../../../../models/auto-group/auto-group-setting';
import { CampaignService } from '../../../../../services/campaign/campaign.service';
import { BrandedSignUp } from '../../../../../../models/auto-group/branded-sign-up';
var AutoGroupSourceItemComponent = /** @class */ (function () {
    function AutoGroupSourceItemComponent(translate, userService, eventTracker, referenceDataService, campaignService) {
        this.translate = translate;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.referenceDataService = referenceDataService;
        this.campaignService = campaignService;
        this.AutoGroupSourceHasValues = [AutoGroupSourceEnum.TOPICS, AutoGroupSourceEnum.INDUSTRIES, AutoGroupSourceEnum.CAMPAIGNS, AutoGroupSourceEnum.LOOKALIKE];
        this.instagramErrorMsg = 'Missing value';
        this.otherOption = 'Other';
        this.AutoGroupSourceHasSingleValue = [AutoGroupSourceEnum.MENTIONS, AutoGroupSourceEnum.LOOKALIKE];
        this.availableAutoGroupSourceList = [];
        this.listProject = [];
        this.campaignList = [];
        this.influencerGroupList = [];
        this.deleteGroupSourceEvent = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.changeGroupSourceEvent = new EventEmitter();
        this.sourceValueList = [];
        this.showStaticValue = false;
        this.showValueDropdownList = false;
        this.showInstagramFollower = false;
        this.showProjectList = false;
        this.showBrandedSignUp = false;
        this.noAvailabelCampaign = false;
        this.fieldErrors = [];
        this.mappedSourceValues = [];
    }
    AutoGroupSourceItemComponent.prototype.ngOnInit = function () {
        this.autoGroupSourceValue = this.sourceItem && this.sourceItem.type && this.AutoGroupSourceHasSingleValue.indexOf(this.sourceItem.type) >= 0 ? null : [];
        if (this.sourceItem && this.sourceItem.type && this.sourceItem.sourceValues.length > 0) {
            this.mappingSourceItemData();
        }
    };
    AutoGroupSourceItemComponent.prototype.ngOnChanges = function (changes) {
        if (changes.sourceItem) {
            this.mappingSourceItemData();
        }
        if (changes.listProject) {
            this.updateProjectList(changes.listProject.currentValue);
        }
    };
    AutoGroupSourceItemComponent.prototype.mappingSourceItemData = function () {
        if (this.sourceItem && this.sourceItem.type) {
            this.selectedSources = this.sourceItem.type;
            this.selectSourceType({ id: this.sourceItem.type }, false);
            if (this.AutoGroupSourceHasValues.indexOf(this.sourceItem.type) >= 0) {
                this.mappingAutoGroupSourceValue();
            }
            if (this.sourceItem.type === AutoGroupSourceEnum.MENTIONS) {
                this.selectedProject = this.sourceItem.sourceValues[0].id;
                this.reloadProjectList();
            }
            if (this.sourceItem.type === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
                this.instagramFollwerValue = this.sourceItem.sourceValues[0].name;
            }
            if (this.sourceItem.type === AutoGroupSourceEnum.BRANDED_SIGNUP && this.brandedSignUpConfig) {
                this.showBrandedSignUp = true;
                this.showStaticValue = true;
                this.sourceStaticValue = this.brandedSignUpConfig.brandName;
                this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.from');
            }
        }
    };
    AutoGroupSourceItemComponent.prototype.mappingAutoGroupSourceValue = function () {
        if (this.sourceItem.type === AutoGroupSourceEnum.LOOKALIKE) {
            this.autoGroupSourceValue = this.sourceItem.sourceValues[0].id;
        }
        else {
            this.autoGroupSourceValue = this.sourceItem.sourceValues.map(function (item) {
                return item.id;
            });
        }
    };
    AutoGroupSourceItemComponent.prototype.reloadProjectList = function () {
        var _this = this;
        var mappedProjectList = this.listProject.filter(function (item) { return item.id === _this.sourceItem.sourceValues[0].id; });
        var createProjectItem = [
            {
                id: 0,
                name: this.translate.instant('measure.create_new_project')
            }
        ];
        mappedProjectList = mappedProjectList.concat(createProjectItem);
        mappedProjectList = mappedProjectList.concat(this.listProject.filter(function (listItem) { return mappedProjectList.every(function (item) { return item.id !== listItem.id && listItem !== 0; }); }));
        this.listProject = mappedProjectList;
    };
    AutoGroupSourceItemComponent.prototype.selectSourceType = function (evt, needToRecalculateSourceTypeOption) {
        var _this = this;
        if (needToRecalculateSourceTypeOption === void 0) { needToRecalculateSourceTypeOption = true; }
        this.fieldErrors = [];
        this.errorMessage = null;
        this.hasSelectedSource = evt ? true : false;
        this.showValueDropdownList = evt && evt.id && this.AutoGroupSourceHasValues.indexOf(evt.id) >= 0;
        this.showStaticValue = false;
        this.showInstagramFollower = false;
        this.showProjectList = false;
        this.autoGroupSourceValue = evt && evt.id && this.AutoGroupSourceHasSingleValue.indexOf(evt.id) >= 0 ? null : [];
        this.selectedProject = null;
        this.noAvailabelCampaign = false;
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.TOPICS) {
            this.loadTopicListAndComparison();
        }
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.INDUSTRIES) {
            this.loadIndustriesListAndComparison();
        }
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.CAMPAIGNS) {
            this.loadCampaignListAndComparison();
        }
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.MENTIONS) {
            this.showProjectList = true;
            if (!this.listProject || this.listProject.length === 0) {
                this.updateProjectList(this.listProject);
                this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
                    _this.listProject = res ? res.data : [];
                    _this.updateProjectList(_this.listProject);
                });
            }
            else {
                this.updateProjectList(this.listProject);
            }
            this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
        }
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
            this.showInstagramFollower = true;
            this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.from');
        }
        if (evt && evt.id && evt.id === AutoGroupSourceEnum.LOOKALIKE) {
            this.loadInfluencerGroupListAndComparison();
        }
        if (needToRecalculateSourceTypeOption) {
            this.changeGroupSourceEvent.emit(this.sourceItem);
        }
    };
    AutoGroupSourceItemComponent.prototype.loadTopicListAndComparison = function () {
        var _this = this;
        var activeTopicList = this.referenceDataService.activeTopics.filter(function (item) { return item.name !== _this.otherOption; });
        this.sourceValueList = activeTopicList.map(function (item) { return ({
            id: item.id,
            name: item.name,
            value: item.name
        }); });
        this.valueDropdownPlaceholder = this.translate.instant('discover.search_bar.topic_placeholder');
        this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
    };
    AutoGroupSourceItemComponent.prototype.loadIndustriesListAndComparison = function () {
        var _this = this;
        var industriesList = this.referenceDataService.verticals.filter(function (item) { return item.name !== _this.otherOption; });
        this.sourceValueList = industriesList.map(function (item) { return ({
            id: item.id,
            name: item.name,
            value: item.name
        }); });
        this.valueDropdownPlaceholder = this.translate.instant('discover.search_bar.industry_placeholder');
        this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
    };
    AutoGroupSourceItemComponent.prototype.loadInfluencerGroupListAndComparison = function () {
        var _this = this;
        var activeGroup = this.influencerGroupList.find(function (listItem) { return listItem.id === _this.influencerGroupId; });
        var otherGroups = this.influencerGroupList.filter(function (listItem) { return listItem.id !== _this.influencerGroupId; });
        this.sourceValueList = [];
        if (activeGroup) {
            var thisGroupName = this.translate.instant('new_group_settings.auto_group_sources.this_group');
            var thisGroup = Object.assign({}, activeGroup, {
                name: thisGroupName,
                value: thisGroupName
            });
            this.sourceValueList.push(thisGroup);
        }
        this.sourceValueList = this.sourceValueList.concat(otherGroups);
        this.valueDropdownPlaceholder = this.translate.instant('new_group_settings.auto_group_sources.group_list_placeholder');
        this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.based_on');
    };
    AutoGroupSourceItemComponent.prototype.loadCampaignListAndComparison = function () {
        var _this = this;
        if (this.campaignList && this.campaignList.length === 0) {
            this.campaignService.getCampaignFullListForCompany(this.userService.getCompanyId(), false).subscribe(function (res) {
                _this.campaignList = res.campaigns.map(function (cp) { return ({
                    id: cp.id,
                    name: cp.name,
                    value: cp.name
                }); });
                _this.processCampaignListAndComparison();
            });
        }
        else {
            this.processCampaignListAndComparison();
        }
    };
    AutoGroupSourceItemComponent.prototype.processCampaignListAndComparison = function () {
        this.sourceValueList = this.campaignList;
        this.showStaticValue = this.sourceValueList.length === 0;
        this.sourceStaticValue = this.sourceValueList.length === 0 ? this.translate.instant('new_group_settings.auto_group_sources.no_available_campaigns') : null;
        this.showValueDropdownList = this.sourceValueList.length !== 0;
        this.valueDropdownPlaceholder = this.translate.instant('new_group_settings.auto_group_sources.campaign_placeholder');
        this.staticComparison = this.translate.instant('new_group_settings.auto_group_sources.included_in');
    };
    Object.defineProperty(AutoGroupSourceItemComponent.prototype, "isMultipleSelect", {
        get: function () {
            return this.sourceItem.type !== AutoGroupSourceEnum.LOOKALIKE;
        },
        enumerable: true,
        configurable: true
    });
    AutoGroupSourceItemComponent.prototype.afterDeleteProject = function (projectId) {
        var _this = this;
        if (this.selectedProject === projectId) {
            this.selectedProject = null;
        }
        this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
            _this.updateProjectList(res.data);
        });
    };
    AutoGroupSourceItemComponent.prototype.onEditOrCreateProject = function (project) {
        if (project.id > 0) {
            project.keywords = project.projectKeywords.map(function (item) { return item.keyword; });
            project.countries = project.projectCountries.map(function (item) { return item.country.id; });
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.PROJECT, {
                id: project.id,
                name: project.name,
                type: 'Project'
            }, undefined, undefined, {
                type: ActivePages.MEASURE
            });
        }
        this.editOrCreateProjectEvent.emit(project);
    };
    AutoGroupSourceItemComponent.prototype.deleteGroupSource = function () {
        this.deleteGroupSourceEvent.emit(this.sourceItem);
    };
    AutoGroupSourceItemComponent.prototype.validateSources = function () {
        var _this = this;
        this.fieldErrors = [];
        if (!this.sourceItem.type) {
            this.fieldErrors.push(new ValidationError("influencer_group_type_" + this.itemIndex, 'Incomplete source'));
        }
        // no validation for branded signup config
        if (this.sourceItem.type === AutoGroupSourceEnum.BRANDED_SIGNUP) {
            return this.fieldErrors;
        }
        if (this.sourceItem.type === AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS) {
            if (!this.instagramFollwerValue) {
                this.fieldErrors.push(new ValidationError("auto_group_instagram_follower_" + this.sourceItem.type, 'Incomplete source'));
            }
            if (this.instagramFollwerValue && !this.instagramFollwerValue.startsWith('@')) {
                this.fieldErrors.push(new ValidationError("auto_group_instagram_follower_" + this.sourceItem.type, 'Missing value'));
            }
        }
        if (this.haveEmptySourcesValue() || this.haveEmptyCampaignSourceValues()) {
            this.noAvailabelCampaign = this.haveEmptyCampaignSourceValues();
            this.fieldErrors.push(new ValidationError("auto_group_dropdown_value_" + this.sourceItem.type, 'Incomplete source'));
        }
        if (this.sourceItem.type === AutoGroupSourceEnum.MENTIONS && !this.selectedProject) {
            this.fieldErrors.push(new ValidationError("auto_group_project_" + this.sourceItem.type, 'Incomplete source'));
        }
        if (this.fieldErrors.length > 0) {
            this.errorMessage = this.fieldErrors.filter(function (errorItem) { return errorItem.message === _this.instagramErrorMsg; }).length > 0 ? this.translate.instant('new_group_settings.missing_value') : this.translate.instant('new_group_settings.not_complete');
        }
        else {
            this.errorMessage = null;
        }
        return this.fieldErrors;
    };
    /**
     * Check any sources which is not campaign or instagram_follower type has empty value
     */
    AutoGroupSourceItemComponent.prototype.haveEmptySourcesValue = function () {
        return this.sourceItem.type && this.sourceItem.type !== AutoGroupSourceEnum.CAMPAIGNS
            && this.sourceItem.type !== AutoGroupSourceEnum.INSTAGRAM_FOLLOWERS
            && this.sourceItem.type !== AutoGroupSourceEnum.MENTIONS
            && this.autoGroupSourceValue && this.autoGroupSourceValue.length === 0;
    };
    /**
     * Check any sources which is campaign type has empty value
     */
    AutoGroupSourceItemComponent.prototype.haveEmptyCampaignSourceValues = function () {
        return this.sourceItem.type && this.sourceItem.type === AutoGroupSourceEnum.CAMPAIGNS && ((this.campaignList.length > 0
            && this.autoGroupSourceValue && this.autoGroupSourceValue.length === 0) || this.campaignList.length === 0);
    };
    AutoGroupSourceItemComponent.prototype.updateProjectList = function (projectList) {
        var _this = this;
        if (!projectList || projectList.length === 0 || projectList.filter(function (item) { return item.id === 0; }).length === 0) {
            this.listProject = [{
                    id: 0,
                    name: this.translate.instant('measure.create_new_project')
                }];
        }
        if (Array.isArray(projectList)) {
            this.listProject = this.listProject.concat(projectList.filter(function (projectItem) { return _this.listProject.every(function (item) { return item.id !== projectItem.id; }); }));
        }
    };
    AutoGroupSourceItemComponent.prototype.onFocusOutMentionInput = function () {
        if (this.instagramFollwerValue && this.instagramFollwerValue.startsWith('@')) {
            var instagramSourceValue = new AutoGroupSourceValue();
            instagramSourceValue.id = null;
            instagramSourceValue.name = this.instagramFollwerValue;
            instagramSourceValue.type = this.sourceItem.type;
            this.sourceItem.sourceValues = [instagramSourceValue];
        }
    };
    AutoGroupSourceItemComponent.prototype.closeDropDown = function (evt) {
        if (this.sourceItem.sourceValues.length > 0) {
            this.validateSources();
        }
    };
    AutoGroupSourceItemComponent.prototype.selectValue = function (evt) {
        var _this = this;
        if (!evt) {
            this.autoGroupSourceValue = [];
            return;
        }
        this.mappedSourceValues = [];
        if (this.AutoGroupSourceHasSingleValue.indexOf(this.sourceItem.type) >= 0) {
            this.mappedSourceValues = [{
                    id: evt.id,
                    name: evt.name,
                    type: this.sourceItem.type
                }];
        }
        else {
            this.mappedSourceValues = evt.map(function (item) { return ({
                id: item.id,
                name: item.name,
                type: _this.sourceItem.type
            }); });
        }
        this.sourceItem.sourceValues = this.mappedSourceValues;
    };
    AutoGroupSourceItemComponent.prototype.updateSelectedProject = function (project) {
        this.selectedProject = project.id;
        this.sourceItem.sourceValues = [{
                id: project.id,
                name: project.name,
                type: this.sourceItem.type
            }];
    };
    AutoGroupSourceItemComponent.prototype.instagramFollowerInputKeyDown = function (evt) {
        this.errorMessage = evt.target.value && !evt.target.value.startsWith('@') ? this.translate.instant('new_group_settings.missing_value') : null;
    };
    return AutoGroupSourceItemComponent;
}());
export { AutoGroupSourceItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-source-item/auto-group-source-item.component.ts.pre-build-optimizer.js